enum EHinweis{
  MONATLICHE_RATE_WURDE_REDUZIERT = "MONATLICHE_RATE_WURDE_REDUZIERT",
  MONATLICHE_RATE_WURDE_ERHOEHT = "MONATLICHE_RATE_WURDE_ERHOEHT",
  KAUFPREIS_WURDE_IN_RANGE_GESETZT = "KAUFPREIS_WURDE_IN_RANGE_GESETZT",
  DARLEHEN_WURDE_IN_RANGE_GESETZT = "DARLEHEN_WURDE_IN_RANGE_GESETZT",
  DARLEHEN_WURDE_AUF_MAX_BELEIHUNG_GESETZT = "DARLEHEN_WURDE_AUF_MAX_BELEIHUNG_GESETZT",
  EIGENKAPITAL_REDUZIERT = "EIGENKAPITAL_REDUZIERT",
}

export default EHinweis;
